(function () {
  const SEARCH_FORM_SELECTOR = '[data-tbh-collection-search]';
  const SEARCH_INPUT_SELECTOR = '[data-tbh-collection-search-input]';
  const PRODUCT_CARD_SELECTOR = '[data-tbh-product-card]';
  const EMPTY_MESSAGE_CLASS = 'tbh-collection-search-empty';
  const DEBOUNCE_MS = 1200;
  const FADE_MS = 220;

  const normalize = (value) => value.toLowerCase().replace(/\s+/g, ' ').trim();

  const getCards = () => Array.from(document.querySelectorAll(PRODUCT_CARD_SELECTOR));

  const getProductGrid = () => document.querySelector('.product-grid');

  const getCountLabel = () => document.querySelector('.products-count-wrapper [role="status"]');

  const updateCount = (visibleCount, totalCount, query) => {
    const countLabel = getCountLabel();
    if (!countLabel) return;
    countLabel.textContent = !query
      ? `${totalCount} ${totalCount === 1 ? 'item' : 'items'}`
      : `${visibleCount} ${visibleCount === 1 ? 'item' : 'items'}`;
  };

  const updateEmptyMessage = (visibleCount, query) => {
    const grid = getProductGrid();
    if (!grid) return;
    let emptyMessage = document.querySelector(`.${EMPTY_MESSAGE_CLASS}`);
    if (!emptyMessage) {
      emptyMessage = document.createElement('p');
      emptyMessage.className = EMPTY_MESSAGE_CLASS;
      emptyMessage.textContent = 'No products match your search.';
      grid.insertAdjacentElement('afterend', emptyMessage);
    }
    emptyMessage.hidden = !query || visibleCount > 0;
  };

  const showCard = (card) => {
    card.hidden = false;
    card.classList.remove('tbh-collection-card-hidden');
    // Force repaint before fading in so the transition fires
    void card.offsetHeight;
    card.classList.remove('tbh-card-out');
  };

  const hideCard = (card) => {
    card.classList.add('tbh-card-out');
    setTimeout(() => {
      card.hidden = true;
      card.classList.add('tbh-collection-card-hidden');
    }, FADE_MS);
  };

  const filterCards = (input) => {
    const grid = getProductGrid();
    if (grid) grid.classList.remove('tbh-grid-waiting');
    const form = document.querySelector(SEARCH_FORM_SELECTOR);
    if (form) form.classList.remove('tbh-grid-waiting');

    const query = normalize(input.value);
    const queryParts = query.split(' ').filter(Boolean);
    const cards = getCards();
    let visibleCount = 0;

    for (const card of cards) {
      const searchContent = normalize(card.dataset.tbhSearchContent || card.textContent || '');
      const shouldShow = queryParts.length === 0 || queryParts.every((part) => searchContent.includes(part));

      const isCurrentlyHidden = card.hidden || card.classList.contains('tbh-collection-card-hidden');

      if (shouldShow) {
        visibleCount += 1;
        if (isCurrentlyHidden) showCard(card);
      } else {
        if (!isCurrentlyHidden) hideCard(card);
      }
    }

    updateCount(visibleCount, cards.length, query);
    updateEmptyMessage(visibleCount, query);
  };

  const initCollectionSearch = () => {
    const form = document.querySelector(SEARCH_FORM_SELECTOR);
    const input = document.querySelector(SEARCH_INPUT_SELECTOR);

    if (!form || !(input instanceof HTMLInputElement)) return;

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      clearTimeout(form._debounceTimer);
      const grid = getProductGrid();
      if (grid) grid.classList.remove('tbh-grid-waiting');
      filterCards(input);
      input.blur();
    });

    input.addEventListener('input', () => {
      clearTimeout(form._debounceTimer);
      const grid = getProductGrid();
      if (grid) grid.classList.add('tbh-grid-waiting');
      form.classList.add('tbh-grid-waiting');
      form._debounceTimer = setTimeout(() => {
        filterCards(input);
        form.classList.remove('tbh-grid-waiting');
      }, DEBOUNCE_MS);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollectionSearch, { once: true });
  } else {
    initCollectionSearch();
  }
})();
